import { render, staticRenderFns } from "./SupplierDeleteModal.vue?vue&type=template&id=7b6b07f6&scoped=true&"
import script from "./SupplierDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SupplierDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b07f6",
  null
  
)

export default component.exports